// extracted by mini-css-extract-plugin
export default {"wrapper":"wi-z","reviewFormSuccess":"xi-z","header":"yi-z","message":"zi-z","paragraph":"Ai-z","lottieContainer":"Bi-z"};